module.exports = __webpack_public_path__ + "img/springroll_filling.164a2746.jpg";